import React from 'react'
import Image from 'next/image'
import { useTheme } from '@acko-tech/building-blocks.ui.theme'
import svgLoader from '@utils/internalImageLoader'
import { genericTabObj } from '../constant'
import { TabItemRootContainer, ItemImageRootContainer, ItemImageContainer, TabItemText } from './styles'

const GenericTab = props => {
  const { isActive, handleClick, tabType, isFloater, isBlog } = props

  const { theme } = useTheme()

  return (
    <TabItemRootContainer
      onClick={() => {
        handleClick(tabType)
      }}
      isActive={isActive}
      isFloater={isFloater}
      isBlog={isBlog}
      flexDirection="column">
      <ItemImageRootContainer>
        <ItemImageContainer isActive={isActive} theme={theme}>
          <Image
            height={30}
            width={30}
            src={isActive ? genericTabObj[tabType]?.activeIcon : genericTabObj[tabType]?.inActiveIcon}
            alt={genericTabObj[tabType]?.iconAlt}
            loader={svgLoader}
          />
        </ItemImageContainer>
      </ItemImageRootContainer>
      <TabItemText isActive={isActive} className={isActive ? '' : 'hover-opacity'} theme={theme} isFloater={isFloater}>
        {genericTabObj[tabType]?.iconLabel}
      </TabItemText>
    </TabItemRootContainer>
  )
}

export default GenericTab
